/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
// eslint-disable-next-line import/extensions
import * as actionTypes from './ActionTypes';

const showPreloader = (data) => ({
  type: actionTypes.SET_PRELOADER,
  payload: data,
});

export default showPreloader;
